import React, { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import BetSlipContext from "../context/BetSlipContext";
import { isMobile } from "react-device-detect";
const BetSlipIcon = ({ detail }) => {
  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });
  const betPlace = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betPlace;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const setShowParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowParlyBet;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [currentBetCount, setCurrentBetCount] = useState(0);
  const getCurrentBetCount = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.currentBetsCount
    );
    if (status === 200) {
      if (response_users.success) {
        setCurrentBetCount(response_users.results?.total);
      }
    }
  };

  const [show, setShow] = useState(true);
  const [activeWidget, setActiveWidget] = useState("");
  const [widgetsData, setWidgetsData] = useState([]);
  const getWidgets = async (detail) => {
    const { status, data: response_users } = await apiGet(apiPath.matchList, {
      seriesId: detail?.seriesId,
    });
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results?.length > 0) {
          if (isEmpty(activeWidget)) {
            setActiveWidget(detail?._id);
          }
          setWidgetsData(response_users?.results);
        } else {
          setWidgetsData([]);
          setActiveWidget("");
        }
      }
    }
  };
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  useEffect(() => {
    if (!isEmpty(detail)) {
      getWidgets(detail);
    }
  }, [detail]);
  useEffect(() => {
    getCurrentBetCount();
  }, []);
  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type == "matched") {
      getCurrentBetCount();
    }
  }, [betPlace]);
  let nav =
    location?.pathname?.split("/")[location?.pathname?.split("/")?.length - 1];
  const TabShow = () => {
    return (
      <>
        {parlay && parlyBet?.length > 0 && (
          <div
            onClick={() => setShowParlyBet(true)}
            data-v-960519e4
            className="s-relative s-z-20 s-flex s-flex-col s-items-center s-justify-center s-w-42px s-h-39px s-bg-primary s-text-global-font-default-light dark:s-text-global-font-default-dark s-font-bold s-rounded-t-md"
          >
            <span
              data-v-960519e4
              className="s-icon-parlay-list s-absolute s-text-22px s-text-parlay-list-icon"
            />
            <span
              data-v-960519e4
              className="badge s-px-2px s-absolute -s-top-1 s-left-8 s-text-global-font-on-dark s-bg-unread-number-bg s-rounded-full s-text-9px s-h-15px s-flex s-justify-center s-items-center s-font-bold"
            >
              <span data-v-960519e4>{parlyBet?.length}</span>
            </span>
            <div
              data-v-e6652d81
              className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px"
            >
              <svg
                data-v-e6652d81
                width="8px"
                height="8px"
                viewBox="0 0 8 8"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
              >
                <title data-v-e6652d81>tab-radius-l</title>
                <g
                  data-v-e6652d81
                  id="Page-1"
                  stroke="none"
                  strokeWidth={1}
                  fill="none"
                  fillRule="evenodd"
                  data-is-selected="false"
                  className="s-fill-primary"
                >
                  <path
                    data-v-e6652d81
                    d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                    id="tab-radius-l"
                    transform="translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) "
                  />
                </g>
              </svg>
            </div>
            {/**/}
            <div
              data-v-16f79fce
              className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px"
            >
              <svg
                data-v-16f79fce
                width="8px"
                height="8px"
                viewBox="0 0 8 8"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
              >
                <title data-v-16f79fce>tab-radius-r</title>
                <g
                  data-v-16f79fce
                  id="Page-1"
                  stroke="none"
                  strokeWidth={1}
                  fill="none"
                  fillRule="evenodd"
                  data-is-selected="false"
                  className="s-fill-primary"
                >
                  <path
                    data-v-16f79fce
                    d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                    id="tab-radius-r"
                  />
                </g>
              </svg>
            </div>
            {/**/}
          </div>
        )}

        <div
          onClick={() => setShowBets(true)}
          data-v-0510dbc5
          className="s-relative s-z-10 s-flex s-items-center s-justify-center s-w-42px s-h-39px s-text-global-font-on-dark s-rounded-t-md s-bg-betSlip-icon-light dark:s-bg-betSlip-icon-dark"
        >
          <span
            data-v-0510dbc5
            className="s-icon-list s-absolute s-text-22px"
          />

          {currentBetCount > 0 && (
            <span
              data-v-0510dbc5
              className="badge s-px-2px s-absolute -s-top-1 s-left-8 s-text-global-font-light-on-dark s-bg-error-light dark:s-bg-error-dark s-rounded-full s-text-9px s-h-15px s-flex s-justify-center s-items-center s-font-bold"
            >
              <span data-v-0510dbc5>{currentBetCount}</span>
            </span>
          )}
          <div
            data-v-e6652d81
            className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px"
          >
            <svg
              data-v-e6652d81
              width="8px"
              height="8px"
              viewBox="0 0 8 8"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
            >
              <title data-v-e6652d81>tab-radius-l</title>
              <g
                data-v-e6652d81
                id="Page-1"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
                data-is-selected="false"
                className="s-fill-betSlip-icon-light dark:s-fill-betSlip-icon-dark"
              >
                <path
                  data-v-e6652d81
                  d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                  id="tab-radius-l"
                  transform="translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) "
                />
              </g>
            </svg>
          </div>

          <div
            data-v-16f79fce
            className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px"
          >
            <svg
              data-v-16f79fce
              width="8px"
              height="8px"
              viewBox="0 0 8 8"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
            >
              <title data-v-16f79fce>tab-radius-r</title>
              <g
                data-v-16f79fce
                id="Page-1"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
                data-is-selected="false"
                className="s-fill-betSlip-icon-light dark:s-fill-betSlip-icon-dark"
              >
                <path
                  data-v-16f79fce
                  d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                  id="tab-radius-r"
                />
              </g>
            </svg>
          </div>
        </div>
      </>
    );
  };
  return location?.pathname == "/sports" ? (
    <div
      className={
        isMobile
          ? "s-float-button s-w-fit s-m-auto s-z-10 s-fixed s-left-1/2 -s-translate-x-1/2"
          : "s-float-button s-w-fit s-m-auto s-z-10 s-sticky s-left-0"
      }
    >
      <div className="s-flex s-justify-center s-items-center">
        <TabShow />
      </div>
    </div>
  ) : (
    <div
      className="stickyContainer s-w-full s-max-w-[480px] s-fixed s-left-1/2 s-z-30 s-transition-all s-duration-300"
      style={
        isMobile
          ? {
              position: "fixed",
              "-webkit-transform": "translateX(-50%)",
              "-ms-transform": "translateX(-50%)",
              transform: "translateX(-50%)",
              "--6b41a1fc": "0vw",
            }
          : {
              position: "sticky",
              "--bfdb9434": "0vw",
            }
      }
    >
      <div className="s-m-auto s-flex s-justify-center s-items-center">
        <TabShow />
      </div>
      {widgetsData?.length > 0 && show && (
        <div className="s-w-full s-z-30">
          <div
            data-testid="widget-isShowWidget"
            className="s-widget s-relative"
            style={{
              "--867842fe": "160px",
              "--304e5ec4": "rgba(90, 94, 98, 0.5)",
              "--5639f3ec": "rgba(179, 187, 191, 0.75)",
            }}
          >
            <div className="s-bg-secondary s-space-x-2 s-pt-5px">
              <div className="s-h-full s-w-full s-min-h-44px s-flex s-items-center">
                <div className="swiper swiper-initialized swiper-horizontal swiper-free-mode s-cursor-pointer swiper-backface-hidden">
                  <Swiper
                    slidesPerView="auto"
                    freeMode={true}
                    modules={[FreeMode]}
                    className="custom-swiper"
                  >
                    {widgetsData?.map((res) => {
                      return (
                        <SwiperSlide
                          onClick={() =>
                            navigate(
                              nav == "multi"
                                ? `/match-detail/${res?.eventId}/${res?.marketId}/multi`
                                : `/match-detail/${res?.eventId}/${res?.marketId}`
                            )
                          }
                          key={res.id}
                          className={`s-bg-white dark:s-bg-black-800 s-text-global-font-default-light dark:s-text-global-font-default-dark s-rounded-4px s-duration-500 s-relative s-overflow-hidden s-ml-2 last:s-mr-10 ${
                            activeWidget == res?._id
                              ? "s-bg-widget-active-bg dark:s-bg-widget-active-bg  swiper-slide-active"
                              : ""
                          }`}
                          data-testid="widget-active-bg-34665735"
                        >
                          <div
                            data-v-2f9c23fd
                            className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                            style={{ "--0b879273": "0" }}
                          >
                            <span
                              data-v-2f9c23fd
                              className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                              style={{ display: "none" }}
                            />
                            <span
                              data-v-2f9c23fd
                              className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                              style={{ display: "none" }}
                            />
                          </div>
                          <div className="s-flex s-w-full s-h-38px s-justify-between s-items-center s-px-6px s-pt-3px">
                            <div className="s-w-9/12 s-h-full s-pr-3 s-py-4px s-flex s-flex-col s-justify-around s-text-13px">
                              <span className="s-relative s-flex-1 s-flex s-items-center">
                                <span
                                  data-testid="widget-teamName-home-34665735"
                                  className="s-truncate s-h-15px"
                                >
                                  {res?.eventName?.split(" v ")[0]}
                                </span>
                              </span>
                              <span className="s-relative s-flex-1 s-flex s-items-center">
                                <span
                                  data-testid="widget-teamName-away-34665735"
                                  className="s-truncate s-h-15px"
                                >
                                  {res?.eventName?.split(" v ")[1]}
                                </span>
                              </span>
                            </div>
                            <div className="s-w-3/12 s-h-full s-text-13px s-font-bold s-flex s-flex-col s-whitespace-nowrap">
                              <span className="s-flex-1 s-flex s-items-center s-justify-end">
                                <span
                                  className="s-h-15px"
                                  data-testid="widget-scores-home-34665735"
                                >
                                  -
                                </span>
                              </span>
                              <span className="s-flex-1 s-flex s-items-center s-justify-end">
                                <span
                                  className="s-h-15px"
                                  data-testid="widget-scores-away-34665735"
                                >
                                  -
                                </span>
                              </span>
                            </div>
                          </div>

                          <div
                            className={`${
                              activeWidget == res?._id
                                ? "s-bg-widget-info-bg"
                                : "s-bg-black-100 dark:s-bg-black-700"
                            } s-flex s-items-center s-px-6px s-h-15px`}
                          >
                            <div className="s-text-center s-ml-auto">
                              <div className="s-flex s-justify-center s-text-10px s-leading-150 s-space-x-3px">
                                <p>
                                  {" "}
                                  {isDateToday(res?.eventDateTime)
                                    ? "Today"
                                    : moment(res?.eventDateTime).format(
                                        "DD/MM"
                                      )}{" "}
                                  {moment(res?.eventDateTime).format("HH:MM")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>
              <div className="s-text-widget-title s-flex s-items-center s-text-12px s-leading-18px">
                Events of
                <span className="s-ml-3px s-font-bold">
                  {detail?.seriesName}
                </span>
              </div>
            </div>
            <div
              onClick={() => setShow(false)}
              className="s-bg-secondary s-absolute s-top-0 s-bottom-0 s-w-30px s-right-0 s-flex s-items-center s-justify-end s-z-10"
            >
              <div className="s-bg-secondary s-w-30px s-h-full s-flex s-items-center s-justify-center">
                <span
                  data-testid="widget-closeButton"
                  className="s-icon-close s-text-white s-text-10px"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BetSlipIcon;
